import React, { useContext } from 'react';
import Skyflow from 'skyflow-js';
export const skyflowContext = React.createContext({
    vaultID: '',
    vaultURL: '',
    getBearerToken: () => new Promise((resolve) => {
        resolve('');
    }),
    options: {
        logLevel: Skyflow.LogLevel.ERROR,
        env: Skyflow.Env.PROD,
    },
});
const useSkyflow = () => {
    const context = useContext(skyflowContext);
    const skyflow = Skyflow.init(Object.assign({}, context));
    return { skyflow, context };
};
export { useSkyflow };
//# sourceMappingURL=hook.js.map